import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { AddressWithId } from '../services/addressService';

interface ValidationResult {
  isValid: boolean;
  shouldReturn?: boolean;
}

export const useSubscriptionValidation = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const validateUserAuthentication = useCallback((): ValidationResult => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      const currentPath = window.location.pathname + window.location.search;
      navigate(`/register?returnTo=${encodeURIComponent(currentPath)}`, { replace: true });
      return { isValid: false, shouldReturn: true };
    }
    return { isValid: true };
  }, [navigate]);

  const validateAddress = useCallback((
    selectedAddress: AddressWithId | null,
    setShowAddressModal: (show: boolean) => void
  ): ValidationResult => {
    if (!selectedAddress || !selectedAddress.id) {
      toast.error(t('subscription.toasts.addressError'));
      setShowAddressModal(true);
      return { isValid: false, shouldReturn: true };
    }
    return { isValid: true };
  }, [t]);

  const validateGiftInformation = useCallback((
    isGift: boolean,
    senderName: string,
    senderPhone: string
  ): ValidationResult => {
    if (isGift) {
      if (!senderName) {
        toast.error(t('subscription.errors.senderNameRequired'));
        return { isValid: false, shouldReturn: true };
      }
      
      if (!senderPhone) {
        toast.error(t('subscription.errors.senderPhoneRequired'));
        return { isValid: false, shouldReturn: true };
      }
    }
    return { isValid: true };
  }, [t]);

  return {
    validateUserAuthentication,
    validateAddress,
    validateGiftInformation
  };
}; 